import { ReturnBlock } from "../ReturnBlock";

/**
 * A boolean return block that gets if the button is pressed or not
 */
export class ButtonStatusBlock extends ReturnBlock {
    buttonName: string;

    /**
     * Constructor
     * @param id the id.
     * @param buttonName the unique name of this button (what the user sees)
     */
    constructor(id: string, buttonName: string) {
        super(id);
        this.buttonName = buttonName;
    }

    /**
     * Gets the value of '$btn-buttonName' from variable environment.
     * @param varEnv variable environment
     * @returns the boolean value of the button status (false if it does not exist);
     */
    evalBlock(varEnv: Map<string, any>) {
        let val = varEnv.get('&btn-' + this.buttonName); //! come back to this
        return Boolean(val);
    }

}